import React, { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import api from "@/lib/api";
import AiPromptGenerator from "@/components/resume-builder/AiPromptGenerator";

export default function SummarySection({ draft, setDraft }) {
  const [generating, setGenerating] = useState(false);

  const generateSummary = async () => {
    setGenerating(true);
    try {
      const { data } = await api.post("/resume-builder/generate-summary", {
        target_role: draft.target_role, skills: draft.skills,
        experience_titles: draft.experience.map((e) => e.title).filter(Boolean),
      });
      setDraft({ ...draft, summary: data.summary });
    } catch (e) {
      toast.error("Could not generate summary right now");
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div className="glass-panel rounded-2xl p-5" data-testid="resume-section-summary">
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm font-semibold text-white">Professional Summary</p>
        <button onClick={generateSummary} disabled={generating} data-testid="resume-generate-summary-button" className="flex items-center gap-1.5 text-xs font-semibold text-indigo-300 hover:text-indigo-200 disabled:opacity-60">
          {generating ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5" />} Auto-Generate
        </button>
      </div>
      <textarea
        value={draft.summary}
        onChange={(e) => setDraft({ ...draft, summary: e.target.value })}
        placeholder="A 2-4 sentence professional summary..."
        rows={3}
        data-testid="resume-input-summary"
        className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:ring-1 focus:ring-indigo-400 resize-none"
      />
      <div className="mt-2">
        <AiPromptGenerator section="summary" draft={draft} setDraft={setDraft} />
      </div>
    </div>
  );
}
